import React from "react";
import PortableText, {
  getPortableTextColorTheme,
  PortableTextColorTheme,
  PortableTextProps
} from "./PortableText";

export type PortableTextWithBackgroundProps = PortableTextProps & {
  colorTheme: Exclude<
    PortableTextColorTheme,
    PortableTextColorTheme.None | PortableTextColorTheme.Neutral
  >;
};

const PortableTextWithBackground = (props: PortableTextWithBackgroundProps) => {
  const { colorTheme = PortableTextColorTheme.PrimaryDark } = props;

  const { wrapperClasses } = getPortableTextColorTheme(colorTheme);

  return (
    <div className={wrapperClasses}>
      <PortableText
        {...props}
        hasBackground
        elementClasses={{
          p: "text-current last:mb-0",
          h2: "text-current mt-20 first:mt-0",
          h3: "text-current mt-20 first:mt-0",
          h4: "text-current mt-20 first:mt-0",
          h5: "text-current mt-20 first:mt-0",
          h6: "text-current mt-20 first:mt-0"

        }}
      />
    </div>
  );
};

export default PortableTextWithBackground;
